import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../environments/environment';
import { eGENA_Teilnehmerdatensatz } from '../visionet/Teilnehmerdatensatz';
import { eGENA_TeilnehmerInfo } from '../visionet/TeilnehmerInfo';



const routes = {
  getData: (teilnehmerkennung : string) => environment.serverUrl + `/middleware/data/${teilnehmerkennung}`,
  isCurrent: (teilnehmerkennung : string, aktuelleVersion : string) => environment.serverUrl + `/middleware/is-current/${teilnehmerkennung}/${aktuelleVersion}`,
  checkKennung: (teilnehmerkennung : string) => environment.serverUrl + `/middleware/check/${teilnehmerkennung}`,
};

const CHECK_KENNUNG_URL = environment.serverUrl + '/check';
const CHECKLISTEN_URL = environment.serverUrl + '/checklists';


@Injectable()
export class MiddlewareService {


	constructor(private httpClient: HttpClient) { }



	getData(teilnehmerkennung : string): Observable<eGENA_Teilnehmerdatensatz> {
		return this.httpClient.get<eGENA_Teilnehmerdatensatz>(routes.getData(teilnehmerkennung));
	}

	getDataUrl(teilnehmerkennung) : string {
		return routes.getData(teilnehmerkennung) + ", Environment is " + JSON.stringify(environment, null, 4);
	}



	isCurrentet(teilnehmerkennung : string, aktuelleVersion : string): Observable<Boolean> {
		return this.httpClient.get<Boolean>(routes.isCurrent(teilnehmerkennung, aktuelleVersion));
	}

	getIsCurrentUrl() : string {
		return routes.isCurrent("<teilnehmerkennung>", "<aktuelle Version>") + ", Environment is " + JSON.stringify(environment, null, 4);
	}



	checkKennung(teilnehmerkennung : string): Observable<eGENA_TeilnehmerInfo> {
		return this.httpClient.get<eGENA_TeilnehmerInfo>(routes.checkKennung(teilnehmerkennung));
	}

	checkKennungUrl() : string {
		return routes.checkKennung + ", Environment is " + JSON.stringify(environment, null, 4);
	}

}


// WEBPACK FOOTER //
// ./src/services/middleware.service.ts